import { PartFinderReport } from '@/api/generatedApi';
import { usePartFinderReportPolling } from '@/hooks/useDataPolling/usePartFinderReportPolling';
import { StatusBadge } from '@/components/StatusBadge';

export const PartFinderStatusCell = ({ row }: { row: PartFinderReport }) => {
  const report = usePartFinderReportPolling(row);
  return <StatusBadge status={report.status} progress={report.progress} />;
};
